<script>
import Vue from 'vue'
import { API } from '@lib/processors/api-processor'
import { mapGetters } from 'vuex'

export default {
  name: 'EstoreApp',
  computed: {
    ...mapGetters('auth', ['loggedIn']),
    ...mapGetters('ui', ['menu']),
  },
  methods: {
    async handleLoginEvent(data) {
      const authHeader = `Bearer ${data.accessToken}`

      Vue.prototype.$accessToken = data.accessToken
      API.defaults.headers.common['Authorization'] = authHeader

      window.gtag('set', {
        user_id: data.decodedToken['https://eonx.com/user'].id,
      })

      this.$store.dispatch('me/getMe')
    },
  },
}
</script>

<template>
  <app-layout
    id="app"
    :menu="menu"
    title="eStore"
  >
    <router-view />
    <base-modal-wrapper />
  </app-layout>
</template>

<!-- This should generally be the only global CSS in the app. -->
<style lang="scss">
#nprogress .bar {
  background: var(--color-link);
}

.modal-loader {
  height: 200px;
}
</style>
